import React from 'react';
import { Button, View } from './Themed';
import { useColors } from '../constants/useColors';

type CheckBoxProps = {
    checked?:boolean,
    size?:number
    color?:string,
    disabled?:boolean,
    style?: any,
    fill_style?:any
    onSelect:(checked:boolean) => void
}

const Checkbox = ({ checked, size, disabled, color, onSelect, style, fill_style }:CheckBoxProps) => {
    const Colors = useColors()
    const box_size = size ?? 20
    const box_color = color ?? Colors.text.h1
    return (
        <Button 
            disabled={disabled}
            style={{ height:box_size, width:box_size, padding:5, borderWidth:1, borderRadius:4, borderColor:box_color, justifyContent:'center', alignItems:'center', ...style }}
            onPress={() => onSelect(checked ? false : true)}
            >
            {checked ?
            <View style={{ height:box_size*0.6, width:box_size*0.6, backgroundColor:box_color, ...fill_style }} />
            :<></>}
        </Button>
    )
}

export default Checkbox